import type React from 'react';

import { Card } from '@change/ds-core-ui';

import { craftStarterEmail } from '#src/app/shared/utils/decisionMaker';

import { AutoAddLabel } from './components/AutoAddLabel';
import { DmAvatar } from './components/DmAvatar';
import { EmailDm } from './components/EmailDm';
import { NameAndTitle } from './components/NameAndTitle';
import { NotifiedOrRespondedStatus } from './components/NotifiedOrRespondedStatus';
import { ReadResponse } from './components/ReadResponse';
import { useDmCards } from './hooks/useDmCards';

export const DmCards: React.FC = () => {
	const {
		data: { ask, slug, starterDisplayName, signatureCount, emailDm, decisionMakers, allDmResponses },
		actions: { trackProfileLinkClick, trackEmailDmClick, trackReadResponseClick },
	} = useDmCards();

	if (decisionMakers.length === 0) return null;

	return (
		<div className="flex flex-col gap-6">
			{decisionMakers.map(
				({ photo, publiclyVisible, slug: dmSlug, displayName, title, email, id, targetPetitionAssociationData }) => {
					const responses = allDmResponses.filter((response) => response.decisionMaker.id === id);
					const hasResponded = responses.length > 0;
					const isNotified =
						(!!targetPetitionAssociationData?.daysSinceNotified || signatureCount > 9) && !(responses.length > 0);

					let emailHref = 'mailto:';
					if (email) {
						emailHref = craftStarterEmail({
							ask,
							slug,
							dmName: displayName,
							dmEmail: email,
							starterDisplayName,
							signatureCount: signatureCount.toString(),
							emailDm,
						});
					}

					return (
						<Card key={id} className="p-6" data-qa={`dm-card-${id}`} elevation>
							<div data-testid={`dm-${id}`} data-qa={`dm-${id}`} className="flex flex-col gap-4">
								<div className="flex flex-row gap-4">
									<DmAvatar displayName={displayName} photo={photo} />

									<div>
										<div className="flex flex-col gap-4">
											<NameAndTitle
												id={id}
												displayName={displayName}
												title={title}
												dmSlug={dmSlug}
												publiclyVisible={publiclyVisible}
												trackProfileLinkClick={trackProfileLinkClick}
											/>
											<NotifiedOrRespondedStatus
												daysSinceNotified={targetPetitionAssociationData?.daysSinceNotified}
												isNotified={isNotified}
												hasResponded={hasResponded}
											/>
											<div className="md:hidden">
												<EmailDm id={id} email={email} emailHref={emailHref} trackEmailDmClick={trackEmailDmClick} />
											</div>

											<ReadResponse responses={responses} slug={slug} trackReadResponseClick={trackReadResponseClick} />
										</div>
									</div>
									<div className="hidden md:ml-auto md:flex md:flex-row md:items-center">
										<EmailDm id={id} email={email} emailHref={emailHref} trackEmailDmClick={trackEmailDmClick} />
									</div>
								</div>
								<AutoAddLabel targetPetitionAssociationData={targetPetitionAssociationData} />
							</div>
						</Card>
					);
				},
			)}
		</div>
	);
};
